import React from 'react';
import { useParams } from 'react-router-dom';
import Banner from '../../../components/collection/CollectionDetailsVideo';
import CollectionTabs from '../../../components/collection/CollectionTabs';

const CollectionDetails = () => {
    // Extract the collection address from URL parameters
    const { collectionAddress } = useParams();

    // Debugging: Log the collection address (Remove in production)
    console.log("Collection Address:", collectionAddress);

    return (
        <div>
            {/* Banner Section - Displays collection details */}
            <Banner contractAddress={collectionAddress} />

            {/* Tabs Section - Displays collection-related content */}
            <div className="container">
                <CollectionTabs contractAddress={collectionAddress} />
            </div>
        </div>
    );
};

export default CollectionDetails;
